"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = _interopRequireDefault(require("../color/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var charcoal = _base.default.charcoal;
var scale = [{
  xOffset: 0,
  yOffset: 1,
  size: 4,
  color: charcoal,
  opacity: 0.4
}, {
  xOffset: 0,
  yOffset: 2,
  size: 5,
  color: charcoal,
  opacity: 0.4
}, {
  xOffset: 0,
  yOffset: 3,
  size: 6,
  color: charcoal,
  opacity: 0.25
}];
var alias = {
  default: scale[0],
  skyPlane1: scale[0],
  skyPlane2: scale[1],
  skyPlane3: scale[2]
};
var _default = {
  scale: scale,
  alias: alias
};
exports.default = _default;